'use client'
import React from 'react'

import { HeaderContainer } from '@/src/components/common/Header'

import ErrorBoundaryWrapper from '@/src/containers/common/ErrorBoundary'
import useRedirectToHome from '@/src/hooks/navigation/useRedirectToHome'
import { useTranslations } from 'next-intl'
import { PaymentFailure } from './paymentFailure'

interface PaymentFailureWrapperProps {
    isMobile: boolean
}

const PaymentFailureWrapper: React.FC<PaymentFailureWrapperProps> = ({ isMobile }) => {
    const goToHome = useRedirectToHome()
    const t = useTranslations('confirmationFailure')

    return (
        <>
            {!isMobile && (
                <ErrorBoundaryWrapper identifier="HeaderContainer-desktop-wrapper-paymentFailure">
                    <HeaderContainer />
                </ErrorBoundaryWrapper>
            )}
            <PaymentFailure
                title={t('paymentfailureTitle')}
                subtitle={t('paymentfailureSubTitle')}
                primaryButtonText={t('buttonCta')}
                onBackClick={(isReloadRequired: boolean) => {
                    goToHome({ isReloadRequired })
                }}
            />
        </>
    )
}

export { PaymentFailureWrapper }
export default PaymentFailureWrapper
